import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
import type { LinkProps } from '@tanstack/react-router';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

type ButtonLinkProps = Omit<ButtonProps<'a'>, 'component'> & LinkProps;

const UnwrappedButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>((props, ref) => {
  const { variant = 'contained', size = 'medium', sx, ...rest } = props;

  // eslint-disable-next-line @typescript-eslint/no-misused-spread
  return <Button ref={ref} component="a" size={size} sx={{ borderRadius: 0, ...sx }} variant={variant} {...rest} />;
});

export const FormButtonLink = createLink(UnwrappedButtonLink);
